import { Skeleton } from '@ria-client/tw-shadcn/components/skeleton';

export interface ProductCardSkeletonProps {
  ourTakeExpanded?: boolean;
}

export function ProductCardSkeleton({ ourTakeExpanded = false }: ProductCardSkeletonProps) {
  return (
    <div className="border-2 border-border">
      <div className="px-3 py-3 md:px-4">
        <div className="mb-3">
          <Skeleton className="h-10 w-[250px] rounded" />
        </div>
        <div className="flex flex-col md:flex-row">
          <div className="mr-0 flex w-full flex-col gap-3 md:mr-6 md:w-auto md:flex-row">
            <div className="w-full md:w-[200px]">
              <Skeleton className="h-[90px] w-full rounded" />
              <Skeleton className="mt-2 h-[60px] w-full rounded" />
            </div>
            <div className="hidden flex-col gap-2 md:flex">
              <Skeleton className="h-[30px] w-[200px] rounded" />
              <Skeleton className="h-10 w-[180px] rounded" />
            </div>
          </div>
          <div className="mt-3 flex flex-1 flex-col gap-2 md:mt-0">
            {Array.from({ length: 4 }).map((_, index) => (
              <div
                className="flex items-center border-b border-border pb-2 last:border-b-0 last:pb-0"
                key={index}
              >
                <div className="basis-1/4 gap-1">
                  <Skeleton className="h-[30px] w-[150px] rounded" />
                </div>
                <Skeleton className="ml-3 h-[30px] w-[100px] rounded" />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="mb-2 flex h-12 items-center gap-1 px-3 py-2">
          <Skeleton className="h-5 w-[150px] rounded" />
        </div>
        {ourTakeExpanded && (
          <div
            className="flex h-[500px] flex-col gap-3 p-3"
            data-testid="product-card-skeleton-details"
          >
            {Array.from({ length: 5 }).map((_, index) => (
              <Skeleton className="h-20 w-full rounded" key={index} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
